export default {"src":"/_next/static/media/youtube-social.0f873265.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};